// **React Imports
import React, { memo, useCallback, useMemo } from 'react'

// **MUI Imports
import { Box, MenuItem, styled, Typography } from '@mui/material'

// **Redux Imports
import { useSelector } from 'react-redux'

// **Utils Imports
import { APP_MODE, APP_MODES_DATA } from '../../../utils/constant'
import { setAppModeInStorage } from '../../../utils/utils'

// **Component Imports
import Icon from '../../icon'

// **Styled Component
const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  '&.selected': {
    boxShadow: theme.shadows[2],
    backgroundColor: theme.palette.primary.main,
    color: `${theme.palette.common.white} !important`,
    '&:hover': {
      backgroundColor: theme.palette.primary.main
    },
    '&:hover .MuiBox-root, &:hover .MuiBox-root svg': {
      color: `${theme.palette.common.white} !important`
    }
  },
  '&:hover .MuiBox-root, &:hover .MuiBox-root svg': {
    color: theme.palette.text.primary
  }
}))

// **static style

const styles = {
  px: 4,
  py: 1.75,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  '& svg': {
    fontSize: '1.5rem',
    color: 'text.secondary'
  }
}

const LearnerToggle = () => {
  // Redux State
  const appMode = useSelector((state) => state.auth.appMode)

  // Variable
  const selectedValue = useMemo(() => {
    return (
      APP_MODES_DATA?.find((mode) => mode?.value === appMode) ||
      APP_MODES_DATA?.[0]
    )
  }, [appMode])

  // Handlers

  const handleAppModeChange = useCallback((value) => {
    setAppModeInStorage(value)
    window.location.href = window.location.origin
  }, [])

  return (
    <>
      {selectedValue && (
        <MenuItemStyled sx={{ p: 0 }}>
          <Box
            sx={styles}
            onClick={() =>
              handleAppModeChange(
                APP_MODES_DATA?.[
                  selectedValue.value === APP_MODE.HIRING ? 1 : 0
                ]?.value
              )
            }
          >
            <Icon
              icon={
                APP_MODES_DATA?.[
                  selectedValue.value === APP_MODE.HIRING ? 1 : 0
                ]?.icon
              }
              style={{ marginRight: '6px', fontSize: '22px' }}
            />
            <Typography sx={{ mr: 1.5 }}>{`Switch to ${
              APP_MODES_DATA?.[selectedValue.value === APP_MODE.HIRING ? 1 : 0]
                ?.label
            } Mode`}</Typography>
          </Box>
        </MenuItemStyled>
      )}
    </>
  )
}

export default memo(LearnerToggle)
